module.exports = __webpack_public_path__ + "img/wl_prod2_1.57440579.jpg";